import { useEffect, useState } from "react";
import api from "@/lib/api";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import AtelierSteps from "@/components/AtelierSteps";
import Workshops from "@/components/Workshops";
import Booking from "@/components/Booking";
import GiftSection from "@/components/GiftSection";
import FavoritesSection from "@/components/FavoritesSection";
import CafeMenu from "@/components/CafeMenu";
import InfoFooter from "@/components/InfoFooter";

export default function Landing() {
  const [content, setContent] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("tad_content")) || null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    api.get("/content").then((r) => {
      setContent(r.data);
      try {
        localStorage.setItem("tad_content", JSON.stringify(r.data));
      } catch {}
    }).catch(() => setContent((c) => c || {}));
  }, []);

  return (
    <div data-testid="landing-page" className="bg-[#FBF8F3] min-h-screen">
      <div className="grain-overlay" />
      <Nav content={content} />
      <Hero content={content} />
      <Marquee />
      <AtelierSteps content={content} />
      <Workshops />
      <Booking content={content} />
      <GiftSection content={content} />
      <FavoritesSection />
      <CafeMenu content={content} />
      <InfoFooter content={content} />
    </div>
  );
}
